import { apiClient as api } from "./httpClient";

// Mensagens de WhatsApp da entidade (RN-545): texto com variáveis {{chave}} do catálogo fixo do
// servidor; uma é a padrão (a que a Agenda do dia já traz escolhida). MetaTemplateName fica
// reservado para a automação por API, que só envia template aprovado pela Meta.

export interface WhatsAppMessageTemplate {
  id: string;
  name: string;
  body: string;
  isDefault: boolean;
  metaTemplateName: string | null;
  active: boolean;
  variablesUsed: string[];
}

export interface WhatsAppMessageVariable {
  key: string;
  label: string;
  sample: string;
}

export interface SaveWhatsAppMessagePayload {
  name: string;
  body: string;
  metaTemplateName: string | null;
}

export const whatsappMessagesService = {
  getByEntity: async (entityId: string, includeInactive = true): Promise<WhatsAppMessageTemplate[]> => {
    const response = await api.get(`/whatsapp-messages/by-entity/${entityId}?includeInactive=${includeInactive}`);
    return response.data;
  },

  variables: async (): Promise<WhatsAppMessageVariable[]> => {
    const response = await api.get("/whatsapp-messages/variables");
    return response.data;
  },

  preview: async (body: string): Promise<string> => {
    const response = await api.post("/whatsapp-messages/preview", { body });
    return response.data.text;
  },

  create: async (entityId: string, payload: SaveWhatsAppMessagePayload): Promise<string> => {
    const response = await api.post("/whatsapp-messages", { entityId, ...payload });
    return response.data.id;
  },

  update: async (id: string, payload: SaveWhatsAppMessagePayload): Promise<void> => {
    await api.put(`/whatsapp-messages/${id}`, payload);
  },

  setActive: async (id: string, active: boolean): Promise<void> => {
    await api.patch(`/whatsapp-messages/${id}/active`, { value: active });
  },

  setDefault: async (id: string, isDefault: boolean): Promise<void> => {
    await api.patch(`/whatsapp-messages/${id}/default`, { value: isDefault });
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/whatsapp-messages/${id}`);
  },
};
